import { render, staticRenderFns } from "./AclUsuario.vue?vue&type=template&id=7b08567d"
import script from "./AclUsuario.vue?vue&type=script&lang=js"
export * from "./AclUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports